import ListBanquesToPayement from "../../../models/ListBanquesToPayement";
import { useEffect } from "react";
import withLoader from "../../layouts/WithLoader"
import { TextField } from "@material-ui/core";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useState } from "react";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import SalesService from "../../../services/SellingService";
import UploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import BCService from "../../../services/BC";
import PrintableK from "../../../pages/banque/PrintableK";
import BanqueService from "../../../services/Banque";
import nombreEnTexte from "../../../utils/NombreEnTexte";


const PayementTotalBillChequeFN = ({ startLoading, stopLoading }) => {
    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [errorAlertText, setErrorAlertText] = useState();
    const [datePayementCheque, setDatePayementCheque] = useState("");
    const [codePayementCheque, setCodePayementCheque] = useState("");
    const [fileName, setFileName] = useState("");
    const [openInfoAlert, setOpenInfoAlert] = useState(false);

    const [infoAlertText, setInfoAlertText] = useState();
    const [file, setFile] = useState([]);

    const [amount, setAmount] = useState();
    const [data, setData] = useState({
        date1: '',
        city: '',
        date2: new Date().toISOString().split('T')[0], // Current date in 'YYYY-MM-DD' format
        reference: '',
        amount: localStorage.getItem("restToPay"),
        message1: "",
        message2: "",
        amountWords: nombreEnTexte(localStorage.getItem("restToPay")),
        name: '',
        testMessage: '',
        bank: '',
        adresse:''
    });

    useEffect(() => {
        if (localStorage.getItem('client') && localStorage.getItem('company')) {
            setData((prevData) => ({
                ...prevData,
                message1: localStorage.getItem('client'),
                message2: localStorage.getItem('client'), // If this is intentional
                name: localStorage.getItem('company'),
                adresse: localStorage.getItem('adresse')
            }));
        }

        const fetchBankAccounts = async () => {
            try {
                const response = await BanqueService.getAllBankAccounts(1);
                if (response.data?.Banque) {
                    // Handle the case where "Banque" exists but is empty or contains data
                } else if (response.data?.success?.length > 0) {
                    const bankDetails = response.data.success[0];


                    setData((prevData) => ({
                        ...prevData,
                        reference: bankDetails?.rib,
                        bank: bankDetails?.name,
                    }));
                }
            } catch (error) {
                console.error("Error fetching bank accounts:", error);
            }
        };

        fetchBankAccounts();
    }, []);

    const changeDatePayementCheque = (event) => {
        setDatePayementCheque(event.target.value.concat(":59"));
        setData({
            ...data,
            date1: event.target.value.split('T')[0], // Update the city value in the state
        }); function nombreEnTexte(nombre) {
            const unites = ["", "un", "deux", "trois", "quatre", "cinq", "six", "sept", "huit", "neuf"];
            const dizaines = ["", "dix", "vingt", "trente", "quarante", "cinquante", "soixante", "soixante", "quatre-vingt", "quatre-vingt"];
            const exceptions = ["dix", "onze", "douze", "treize", "quatorze", "quinze", "seize"];

            if (nombre === 0) return "zéro";

            function convertir(n) {
                if (n < 10) return unites[n];
                if (n < 17) return exceptions[n - 10];
                if (n < 20) return "dix-" + unites[n - 10];
                if (n < 70) {
                    const dizaine = Math.floor(n / 10);
                    const unite = n % 10;
                    return dizaines[dizaine] + (unite === 1 ? "-et-" : (unite > 0 ? "-" : "")) + unites[unite];
                }
                if (n < 80) {
                    return "soixante-" + convertir(n - 60);
                }
                if (n < 100) {
                    const unite = n % 10;
                    return "quatre-vingt" + (unite > 0 ? "-" + unites[unite] : "");
                }
                if (n < 1000) {
                    const centaine = Math.floor(n / 100);
                    const reste = n % 100;
                    return (centaine > 1 ? unites[centaine] + "-cent" : "cent") + (reste > 0 ? "-" + convertir(reste) : "");
                }
                if (n < 1000000) {
                    const mille = Math.floor(n / 1000);
                    const reste = n % 1000;
                    return (mille > 1 ? convertir(mille) + "-mille" : "mille") + (reste > 0 ? "-" + convertir(reste) : "");
                }
                if (n < 1000000000) {
                    const million = Math.floor(n / 1000000);
                    const reste = n % 1000000;
                    return (million > 1 ? convertir(million) + "-millions" : "un-million") + (reste > 0 ? "-" + convertir(reste) : "");
                }
                return "Nombre trop grand à convertir";
            }

            return convertir(nombre);
        }
    };

    // const changeAmount = (event) => {
    //     setAmount(event.target.value);
    // };

    const handleInfoClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenInfoAlert(false);
    };

    const changeCodePayementCheque = (event) => {
        setCodePayementCheque(event.target.value);
    };

    const onUploadFileHandler = (e) => {
        if (e.target.files[0].size > 2097152) {
            setOpenInfoAlert(true);
            setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
        } else {
            setFileName(e.target.files[0].name);

            setFile(e.target.files[0]);
        }
    };
    const handleCityChange = (event) => {
        setData({
            ...data,
            city: event.target.value, // Update the city value in the state
        });
    };
    const handleEroorClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenErrorAlert(false);
    };
    const payerBill = (e) => {
        const url = window.location.pathname.split("/")[1];
        if (url === "payerBill") {
            if (codePayementCheque === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : le code du chèque est vide ");
                // toast.error("Erreur : le champ  code chéque est vide");
            } else if (datePayementCheque === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : la date d'écheance est vide ");
            } else if (amount === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : le montant est vide ");
            } else if (localStorage.getItem("banqueAccount") == null) {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Merci de choisir un compte bancaire ");
            } else {

                let payFactureOrAvance = {
                    idUser: getCurrentUserId(),

                    isFactureOrBDC: 1,
                    idDocument: parseInt(localStorage.getItem("idBill")),

                    isAvanceOrTotalPayement: 1,

                    typePayement: 2,
                    echanceDate: datePayementCheque,
                    ammountPayed: localStorage.getItem("restToPay"),
                    urlFile: "any",
                    banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
                    codeCheque: codePayementCheque,
                };
                startLoading();
                if (file.length !== 0) {
                    const uploadData = new FormData();
                    uploadData.append("picture", file);

                    UploadAndDownloadService.uploadFile(
                        "/retail/uploadFile/uploadFile/Payement",
                        uploadData
                    )
                        .then((response) => {
                            if (response.data["success"]) {
                                payFactureOrAvance.urlFile = response.data.success;
                                BCService.payFactureOrBDC(payFactureOrAvance)

                                    .then((response) => {
                                        console.log(response);
                                        if (response.data["error"]) {
                                            //   toast.error("Error : il ya un probléme");
                                        } else {
                                            setTimeout(() => {
                                                window.location.reload(true);
                                            }, 2000);
                                        }
                                    })
                                    .catch((error) => {
                                        // toast.error("Error : il ya un probléme");

                                        // this.refreshPage();
                                    });
                            } else {
                                // toast.error("Erreur : il ya un probléme au niveau de serveur");
                            }
                        })
                        .catch(() => {
                            //   toast.error("Erreur : il ya un probléme de connection");
                        }).finally(() => {
                            stopLoading();
                        });

                } else {
                    startLoading();

                    BCService.payFactureOrBDC(payFactureOrAvance)
                        .then((response) => {
                            if (response.data["error"]) {
                                // toast.error("Error : il ya un probléme");
                            } else {
                                setTimeout(() => {
                                    window.location.reload(true);
                                }, 2000);
                            }
                        })
                        .catch((error) => {
                            //   toast.error("Error : il ya un probléme");

                            //   this.refreshPage();
                        }).finally(() => {
                            stopLoading();
                        });
                }
            }
        } else {
            if (codePayementCheque === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : le code du chèque est vide ");
                // toast.error("Erreur : le champ  code chéque est vide");
            } else if (datePayementCheque === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : la date d'écheance est vide ");
            } else if (amount === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : le montant est vide ");
            } else if (localStorage.getItem("banqueAccount") == null) {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Merci de choisir un compte bancaire ");
            } else {
                let payementModel = {
                    idUser: getCurrentUserId(),
                    idDocument: parseInt(localStorage.getItem("idBill")),
                    isAvanceOrTotalPayement: 1,
                    isFactureOrBDC: 1,
                    typePayement: 2,
                    echanceDate: datePayementCheque,
                    ammountPayed: localStorage.getItem("restToPay"),
                    urlFile: "any",
                    banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
                    codeCheque: codePayementCheque,
                };
                startLoading();
                if (file.length !== 0) {
                    const uploadData = new FormData();
                    uploadData.append("picture", file);

                    UploadAndDownloadService.uploadFile(
                        "/sales/uploadFileSelling/uploadFile/Payement",
                        uploadData
                    )
                        .then((response) => {
                            if (response.data["success"]) {
                                payementModel.urlFile = response.data.success;
                                SalesService.payFactureOrBDC(payementModel)

                                    .then((response) => {
                                        console.log(response);
                                        if (response.data["error"]) {
                                            //   toast.error("Error : il ya un probléme");
                                        } else {
                                            setTimeout(() => {
                                                window.location.reload(true);
                                            }, 2000);
                                        }
                                    })
                                    .catch((error) => {
                                        console.log("error", error);

                                    })

                            } else {


                            }
                        })
                        .catch(() => {
                            //   toast.error("Erreur : il ya un probléme de connection");
                        })
                        .finally(() => {
                            stopLoading();
                        });
                } else {
                    startLoading();
                    SalesService.payFactureOrBDC(payementModel)

                        .then((response) => {
                            console.log(response);
                            if (response.data["error"]) {
                                //   toast.error("Error : il ya un probléme");
                            } else {
                                setTimeout(() => {
                                    window.location.reload(true);
                                }, 2000);
                            }
                        })
                        .catch((error) => {
                            console.log("error", error);
                            // toast.error("Error : il ya un probléme");

                            //   this.refreshPage();
                        })
                        .finally(() => {
                            stopLoading();
                        });
                }
            }
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <label>Paiement par chèque / traite: </label>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <label>Montant : </label>
                    <input
                        disabled
                        type="number"
                        min="0"
                        step="0.1"
                        class="form-control"
                        // placeholder="Montant "
                        name="amount"
                        value={localStorage.getItem("restToPay")}
                    // onChange={changeAmount}
                    />
                </div>
                <div class="col-md-4">
                    <label>Code Chèque: </label>
                    <input
                        value={codePayementCheque}
                        onChange={changeCodePayementCheque}
                        class="form-control"
                        placeholder="Code du chéque"
                        type="number"
                    />
                </div>

                <div class="col-md-4">
                    <label>Date de l'échéance </label>
                    <br />
                    <TextField
                        style={{ width: "100%" }}
                        className="col-sm-12"
                        variant="outlined"
                        value={datePayementCheque}
                        onChange={changeDatePayementCheque}
                        id="datetime-local"
                        type="datetime-local"
                        defaultValue="date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        size="small"
                    />
                </div>

                <div class="col-md-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div class="form-group">
                                <label for="exampleInputFile">Ajouter chèque </label>
                                <div class="input-group">
                                    <div class="custom-file">
                                        <input
                                            accept="application/pdf, .jpg, .jpeg, .png"
                                            type="file"
                                            className="custom-file-input"
                                            id="exampleInputFile"
                                            onChange={onUploadFileHandler}
                                        />
                                        <label class="custom-file-label" for="exampleInputFile">
                                            {fileName}{" "}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <label>Compte bancaire </label>
                    <ListBanquesToPayement type={1} />
                </div>
                <div className="col-6">
                    <label>Lieux de création</label>
                    <br />
                    <TextField
                        style={{ width: '100%' }}
                        className="col-sm-12"
                        variant="outlined"
                        value={data.city} // Bind the value to data.city
                        onChange={handleCityChange} // Call the handleCityChange function when the value changes
                        type="text"
                        size="small"
                    />
                </div>
                <br />
                <div class="col-12">
                    <button
                        type="submit"
                        onClick={payerBill}
                        className="btn btn-dark float-right my-1"
                    >
                        Payer
                    </button>
                    <PrintableK data={data} />
                </div>
            </div>
            <Snackbar
                open={openErrorAlert}
                autoHideDuration={2000}
                onClose={handleEroorClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleEroorClose} severity="error">
                    {errorAlertText}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openInfoAlert}
                autoHideDuration={4000}
                onClose={handleInfoClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert onClose={handleInfoClose} severity="info">
                    {infoAlertText}
                </Alert>
            </Snackbar>
        </>
    );


}
export default withLoader(PayementTotalBillChequeFN)